import { BareButton } from '@calendly/ui/components/bare-button';
import { FixedContainer } from '@calendly/ui/components/fixed-container';
import { Sheet } from '@calendly/ui/components/sheet';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const styledSheetCss = "se370r8";
export const StyledSheet = forwardRef((props, ref) => <Sheet ref={ref} {...props} className={classNames(styledSheetCss, props.className)} />);
const styledFixedContainerCss = "skkchrx";
export const StyledFixedContainer = forwardRef((props, ref) => <FixedContainer ref={ref} {...props} className={classNames(styledFixedContainerCss, props.className)} />);
const gridWrapperIsPhoneCss = "gcs4rql";
const gridWrapperCss = "g1mfmqaz";
export const GridWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(gridWrapperCss, {
    [gridWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const footerCss = "feczj5v";
export const Footer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(footerCss, props.className)} />;
});
const actionsContainerIsPhoneCss = "aa5ii74";
const actionsContainerCss = "a1lt7z1v";
export const ActionsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(actionsContainerCss, {
    [actionsContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const clearButtonIsPhoneCss = "c1fhzqbb";
const clearButtonCss = "cu6rmqq";
export const ClearButton = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <BareButton ref={ref} {...props} className={classNames(clearButtonCss, {
    [clearButtonIsPhoneCss]: isPhone
  }, props.className)} />;
});
const buttonCss = "bhr0j5g";
const buttonOpenCss = "bpukino";
export const Button = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(buttonCss, props.className)} />);
export { buttonOpenCss };
const numberWrapperCss = "n5b02w1";
export const NumberWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(numberWrapperCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");